import { Alignment, Direction, Displaying, Positioning, Spacing, palette } from "@bonusx-global/bx-design-system";
import { Global } from "@emotion/react";
import styled from "@emotion/styled";
import CssBaseline from "@mui/material/CssBaseline";
import type { PropsWithChildren } from "react";
import { DESKTOP_CONTENT_STYLE } from "../../../components/layouts/default-layout/components/DefaultLayoutDesktop";
import useIsMobile from "../../../hooks/device/useIsMobile";
import { headerHeight, zIndexes } from "../../../R";
import type { IWithIsMobile } from "../../interfaces/IWithIsMobile.interface";
import { BonusXThemeProvider } from "../../theme/BonusXThemeProvider";
import { MOBILE_WRAPPER_INNER_PADDING, WRAPPER_INNER_PADDING } from "../../theme/style.constants";
import CloseChatbotPanelWrapper from "../Chatbot/wrappers/close-chatbot-panel-wrapper/close-chatbot-panel-wrapper";
import { Modal } from "../poppers/Modal";

const HeaderContainer = styled("div")({
  display: Displaying.block,
  position: Positioning.sticky,
  top: Spacing["0"],
  zIndex: zIndexes.one_thousand,
});

interface IWithIsFullHeight {
  isFullHeight: boolean;
}
const BodyContainer = styled("div")<IWithIsFullHeight & IWithIsMobile>(({ isMobile, isFullHeight }) => ({
  ...DESKTOP_CONTENT_STYLE,
  display: Displaying.flex,
  padding: isMobile ? MOBILE_WRAPPER_INNER_PADDING : WRAPPER_INNER_PADDING,
  flexDirection: Direction.column,
  alignItems: Alignment.center,
  gap: Spacing["0"],
  flex: "1 0 0",
  alignSelf: Alignment.stretch,
  height: isFullHeight && isMobile ? `calc(100vh - ${headerHeight})` : "100%",
}));

interface QuestionnaireStepperLayoutProps {
  readonly header: React.ReactNode;
  readonly isFullHeight?: boolean;
  readonly backgroundColor?: string;
}

export function QuestionnaireStepperLayout({
  children,
  header,
  isFullHeight = false,
  backgroundColor = palette?.background?.default,
}: PropsWithChildren<QuestionnaireStepperLayoutProps>): JSX.Element {
  const isMobile = useIsMobile();

  const globalStyles = ` 
    body {
      background-color: ${backgroundColor} !important;
    }
  `;

  return (
    <BonusXThemeProvider>
      <CloseChatbotPanelWrapper>
        <CssBaseline />
        <Modal />
        <Global styles={globalStyles} />
        <HeaderContainer>{header}</HeaderContainer>
        <BodyContainer isMobile={isMobile} isFullHeight={isFullHeight}>
          {children}
        </BodyContainer>
      </CloseChatbotPanelWrapper>
    </BonusXThemeProvider>
  );
}
